import React from 'react'
import flowRight from 'lodash/flowRight'

import LKModal, { LKModalContainer, LKModalTrigger } from 'shared/LKModal'
import { LocalSearchGrid } from 'shared/Helpers'
import LKButton from 'shared/LKButton'

import LKGridConfig from './LKGridConfig'
import translate from './translate'

import container from './container'

const CLIENT_PERMISSION_ADD_MODAL_NAME = 'ClientPermissionAdd'

class ClientPermissionAdd extends React.Component {
  state = {
    permissionID: undefined,
    filtered: [],
  }

  componentDidMount() {
    this.handleModalOpen()
  }

  handleModalOpen = () => {
    const filtered = this.props.lookups.filter((permission) => {
      if (permission.Active === 0) return false

      if (permission.ID <= 0) return false

      const match = this.props.addedPermissions.find((addedPermission) => addedPermission.SEC_UserID === permission.ID)

      if (!match) return true

      return false
    })

    this.setState({ filtered })
  }

  handleInputChange = (filtered) => {
    if (!filtered.length) {
      this.setState({ permissionID: undefined })
    }
  }

  handleRowSelection = (gridRow) => {
    const {
      node: {
        data: { ID },
        selected,
      },
    } = gridRow

    if (selected) {
      this.setState({ permissionID: ID })
    }
  }

  handleSubmit = () => {
    this.props.addPermission(this.state.permissionID)
  }

  render() {
    const { modalInstanceName, loading, lookups } = this.props
    const { filtered } = this.state

    return (
      <LKModal
        name={modalInstanceName}
        heading={translate('frm_sec_RL_add_edit')}
        loading={!lookups}
        size="sm-1"
        footer={
          <LKModal.Footer
            sideActions={
              <LKButton alias="add" onClick={this.handleSubmit} loading={loading} disabled={loading}>
                {translate('cmd_finish')}
              </LKButton>
            }
          />
        }
      >
        <LocalSearchGrid
          data={filtered}
          LKGridConfig={LKGridConfig}
          onRowSelected={this.handleRowSelection}
          searchBy="LoginFull"
          onInputChange={this.handleInputChange}
        />
      </LKModal>
    )
  }
}

export const ClientPermissionAddTrigger = ({ children }) => (
  <LKModalTrigger alias="add" name={CLIENT_PERMISSION_ADD_MODAL_NAME}>
    {children}
  </LKModalTrigger>
)

const enhance = flowRight(LKModalContainer(CLIENT_PERMISSION_ADD_MODAL_NAME), container)

export default enhance(ClientPermissionAdd)
